import type React from 'react';
import { useMeSuspense } from '#admin/hook/useMe.tsx';

type Props = {
  children: React.ReactNode;
};

export const AuthenticatedAppProvider: React.FC<Props> = ({ children }) => {
  // Trigger the user data fetch with suspense
  useMeSuspense();

  return children;
};
